import axiosClient from "./axiosClient";

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const glassKiotService = {
  getListBill: async params => {
    const url = "/store/glasses-sales/searchKey";
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDetailBill: async id => {
    const url = "/store/glasses-sales/by-id";
    const params = {id: id};
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  updateStatusBill: async params => {
    const url = "/store/glasses-sales/update-status";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  payBill: async params => {
    const url = "/store/glasses-sales/thanh-toan";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  returnBill: async params => {
    const url = "/store/glasses-sales/phieu-tra-kinh";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  getListPayments: async () => {
    const url = "/store/payments/list-payments";
    const response = await axiosClient.get(url);
    return response.data;
  },
  getReportStore: async params => {
    const url = "/store/glasses-sales/export-thong-ke-don-ban";
    const res = await axiosClient.get(url, {params: params});
    return res.data;
  },
  getListPatient: async hoTen => {
    const params = {hoTen: hoTen};
    const url = `qlkhambenh/benh-nhan/lay-bang-ho-ten`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
};
export default glassKiotService;
